import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Episode {
    id: string;
    seasonId: string;
    episodeId: string;
    podcastId: string;
    title: string;
    audioUrl: string;
    duration: number;
    coverImage?: string;
    author?: string;
}

interface AudioPlayerState {
    currentEpisode: Episode | null;
    episodes: Episode[];
    isPlaying: boolean;
    volume: number;
    progress: number;
}

const initialState: AudioPlayerState = {
	currentEpisode : null,
	episodes       : [],
	isPlaying      : false,
	volume         : 100,
	progress       : 0
};

const audioPlayerSlice = createSlice({
	name     : 'audioPlayer',
	initialState,
	reducers : {
		setCurrentEpisode : (state, action: PayloadAction<Episode>) =>
		{
			state.currentEpisode = action.payload;
			state.progress = 0;
		},
		setEpisodes : (state, action: PayloadAction<Episode[]>) =>
		{
			state.episodes = action.payload;
		},
		setIsPlaying : (state, action: PayloadAction<boolean>) =>
		{
			state.isPlaying = action.payload;
		},
		setVolume : (state, action: PayloadAction<number>) =>
		{
			state.volume = action.payload;
		},
		setProgress : (state, action: PayloadAction<number>) =>
		{
			state.progress = action.payload;
		},
		playNextEpisode : (state) =>
		{
			if (!state.currentEpisode || state.episodes.length === 0) return;

			const currentIndex = state.episodes.findIndex((ep) => ep.id === state.currentEpisode?.id);

			if (currentIndex < state.episodes.length - 1)
			{
				state.currentEpisode = state.episodes[currentIndex + 1];
				state.progress = 0;
				state.isPlaying = true;
			}
		},
		playPreviousEpisode : (state) =>
		{
			if (!state.currentEpisode || state.episodes.length === 0) return;

			const currentIndex = state.episodes.findIndex((ep) => ep.id === state.currentEpisode?.id);

			if (currentIndex > 0)
			{
				state.currentEpisode = state.episodes[currentIndex - 1];
				state.progress = 0;
				state.isPlaying = true;
			}
		},
		resetPlayer : (state) =>
		{
			state.currentEpisode = null;
			state.isPlaying = false;
			state.progress = 0;
		}
	}
});

export const {
	setCurrentEpisode,
	setEpisodes,
	setIsPlaying,
	setVolume,
	setProgress,
	playNextEpisode,
	playPreviousEpisode,
	resetPlayer
} = audioPlayerSlice.actions;

export default audioPlayerSlice.reducer;